import {actions} from './actions'
import {mutations} from './mutations'
import {getters} from './getters'
import {Module} from 'vuex'
import {RootState} from '@/store'
import {
    DistributionChartSection,
    EtlJobsSection,
    ExternalLinksSection,
    MngCompanyMessageSection,
    TotalsSection,
    LoginAuditChartSection
} from '@/models/LobbyDataResponse.model'

export interface LobbyDataState extends BaseState {
    distributionChartSection: DistributionChartSection
    loginAuditChartSection: LoginAuditChartSection
    totalsSection: TotalsSection
    externalLinksSection: ExternalLinksSection
    mngCompanyMessageSection: MngCompanyMessageSection
    etlJobsSection: EtlJobsSection
}

export const initialState = function (): LobbyDataState {
    return {
        distributionChartSection: {} as DistributionChartSection,
        loginAuditChartSection: {} as LoginAuditChartSection,
        totalsSection: {} as TotalsSection,
        externalLinksSection: {} as ExternalLinksSection,
        mngCompanyMessageSection: {} as MngCompanyMessageSection,
        etlJobsSection: {} as EtlJobsSection,
        isEmpty: true
    }
}

export const lobby: Module<LobbyDataState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}